export enum MessageTypes {
  INVALID = -1,
  WARNING,
  ERROR,
}
